import { DotLoader } from 'react-spinners';
import styled, { css } from 'styled-components';

const getOverlayStyles = (loading) => {
    const isLoading = loading === 'true';
    return {
        opacity: isLoading ? 1 : 0,
        pointerEvents: isLoading ? "all" : "none",
    }
};


const StyledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200000;
  background: rgba(0, 0, 0, 0.5); 
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-in-out;
  opacity: ${(props) => getOverlayStyles(props.loading).opacity}; 
  pointer-events: ${(props) => getOverlayStyles(props.loading).pointerEvents}; 
`;


const override = css`
  display: block;
  margin: 0 auto;
`;

const LoaderOverlay = ({ loading }) => {
    return (
        <StyledOverlay
            loading={loading.toString()} >
            <DotLoader color="#ffffff"
                loading={loading}
                css={override}
                size={50} />
            <div style={{ color: "#ffffff", marginLeft: "10px", fontSize: "1.2rem" }}>
                Loading ...
            </div>
        </StyledOverlay >

    );
};

export default LoaderOverlay;